import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  Input
} from '@angular/core';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {UntypedFormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {debounceTime, map, shareReplay} from 'rxjs/operators';
import {PageEvent} from '@angular/material/paginator';
import {Sort} from '@angular/material/sort';

import {UnitRecipientPaymentsHistoryTableService} from './unit-recipient-payments-history-table.service';
import {UnitPaymentsDataService} from '../../../../../../services/shared/unit-payments-data.service';
import {UnitRecipientPaymentsHistoryDataSource} from './unitRecipientPaymentsHistoryDataSource';
import {UnitPaymentCategory} from '../../models/unit-payment-category.enum';
import {PaymentListItemReadDto} from '../../models/payment/payment-list-item-read-dto.model';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'terra-unit-recipient-payments-history-display-table',
  templateUrl: './unit-recipient-payments-history-display-table.component.html',
  styleUrls: ['./unit-recipient-payments-history-display-table.component.scss', '../../../unit-shared.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0', visibility:'hidden', opacity: 0})),
      state('expanded', style({height: '*', visibility:'visible', opacity: 1})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitRecipientPaymentsHistoryDisplayTableComponent extends OnDestroyMixin implements OnInit {
  @Input() recipientId: number;

  @Output() repeatPayment = new EventEmitter<PaymentListItemReadDto>();

  paymentsPerPage = [25, 50, 100, 200, 500];
  perPageControl = new UntypedFormControl(this.paymentsPerPage[0]);
  dataSource = new UnitRecipientPaymentsHistoryDataSource(this.paymentsHistoryTableService, this.paymentsDataService);
  displayedColumns: string[] = ['date', 'accountName', 'category', 'description', 'amount', 'repeat', 'expand'];

  perPageChanged$: Observable<number> = this.perPageControl.valueChanges.pipe(untilComponentDestroyed(this), debounceTime(200));
  searchOptions$ = this.paymentsHistoryTableService.searchOptions$;
  pageRowsCount$ = this.dataSource.pageRows$.pipe(map(rows => rows ? rows.length : 0), shareReplay(1));
  totalRowsCount$ = this.dataSource.totalRowsCount$;
  isLoading$ = this.dataSource.isLoading$;

  expandedElement:number; 


  // enums
  crePaymentCategory = UnitPaymentCategory;

  constructor(private paymentsHistoryTableService: UnitRecipientPaymentsHistoryTableService,
              private paymentsDataService: UnitPaymentsDataService) {
    super();
  }

  ngOnInit(): void {
    this.perPageChanged$.pipe(untilComponentDestroyed(this)).subscribe(
      pageSize => {
        this.paymentsHistoryTableService.updatePageSize(pageSize);
      });
  }

  trackByFunction(index: number, item: PaymentListItemReadDto) {
    return item.id;
  }

  pageChange(event: PageEvent) {
    this.paymentsHistoryTableService.updatePageNumber(event.pageIndex);
  }

  sortData(sort: Sort) {
    if (!sort.active || !sort.direction) {
      return;
    }

    this.paymentsHistoryTableService.sort(sort.active, sort.direction);
  }

  onRepeat(payment: PaymentListItemReadDto) {
    this.repeatPayment.emit(payment);
  }
}
